/**
 * 表のコンポーネント
 */

/**
 * テーブルのプロパティ
 * @param {string[]} headers - ヘッダーの配列
 * @param {Object[]} data - データの配列
 */
interface TableProps {
  headers: string[];
  data: { [key: string]: any }[];
}

/**
 * テーブルコンポーネント
 * @param {TableProps} props - テーブルのプロパティ
 * @returns {JSX.Element} テーブルのJSX要素
 */
const Table: React.FC<TableProps> = ({
  headers,
  data,
}: TableProps): JSX.Element => {
  return (
    <table className="c-table">
      <thead>
        <tr className="c-table__row">
          {headers.map((header, index) => (
            <th className="c-table__cell c-table__cell--w3" key={index}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr className="c-table__row" key={rowIndex}>
            {headers.map((header, colIndex) => (
              <td className="c-table__cell" key={colIndex}>
                {row[header]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
